import { render } from "./modalSelectAllotmentComponent.vue?vue&type=template&id=71b033a5&scoped=true"
import script from "./modalSelectAllotmentComponent.vue?vue&type=script&lang=js"
export * from "./modalSelectAllotmentComponent.vue?vue&type=script&lang=js"

import "./modalSelectAllotmentComponent.vue?vue&type=style&index=0&id=71b033a5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b033a5"]])

export default __exports__